import type { WrapperFC } from '@george-labs.com/design-system';
import { Flag, Flex, Inline, Select } from '@george-labs.com/design-system';
import type { ItemPropTypes } from '@george-labs.com/design-system/types/components/Dropdown';

import { getFlagDataUrl } from '@shared/core-ui-transfer';

import style from './CountrySelect.module.scss';
import type { CountryCode, GetCountryCallingCode } from './LiphoneApiTypes';

type Props = {
    value?: CountryCode;
    disabled?: boolean;
    items: ItemPropTypes[];
    getCountryCallingCode: GetCountryCallingCode;
    onChange(countryCode: string): void;
};

export const CountrySelect: WrapperFC<Props> = ({
    onChange,
    value,
    disabled,
    items,
    getCountryCallingCode,
}) => {
    const onSelect = (item: ItemPropTypes) => {
        onChange(item.value);
    };

    return (
        <Select
            aria-hidden
            data-cy="country-select"
            name="countrySelect"
            className={style.countrySelect}
            dropdownClassName={style.countryDropdown}
            disabled={disabled}
            value={value}
            items={items}
            renderSelection={({ selection }) => {
                if (!selection) {
                    return null;
                }
                const { value: selectionValue } = selection;
                return (
                    <div>
                        <Flag imageUrl={getFlagDataUrl(selectionValue)} alt={selectionValue} />
                    </div>
                );
            }}
            renderItem={({ item }) => (
                <Flex className="w-100" data-cy={item.value} justify="space-between">
                    <Flex>
                        <Flag
                            className="my-auto"
                            imageUrl={getFlagDataUrl(item.value)}
                            alt={item.value}
                        />
                        <Inline className="ml-2">{item.label}</Inline>
                    </Flex>
                    <Inline
                        data-cy="prefix"
                        className="ml-2 my-auto  text-nowrap"
                    >{`+${getCountryCallingCode(item.value as CountryCode)}`}</Inline>
                </Flex>
            )}
            onSelect={onSelect}
        />
    );
};

CountrySelect.wrapsComponent = Select;
